import { UserAccount } from '@/coreDomainsModule/entities/users';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';
import { UserInfo } from '@/coreInfrastructureModule/axios/generated/userManage';

/**
 * 送られてきたユーザー情報をUserAccount[]に変換するアダプタ
 */
export class UserAdapter {
  /**
   * UserInfo[]をUserAccount[]に変換する
   * @param items - APIからの情報
   */
  public static adapt = (items: UserInfo[]): UserAccount[] => {
    return items.map((item) =>
      UserAccountFactory.create({
        email: item.userId,
        name: item.userName,
        role: item?.userRole,
      })
    );
  };
}
